<script>
	export default {
		props: {
			terms: {
				required: false
			},

			isHome: {
				required: false,
				default:  false
			},

			allTabs: {}
		},

		data() {
			return {
				activeTab: 0,
				countTab:  null
			};
		},

		methods: {
			tabsClick(id, hash) {
				this.activeTab       = parseInt(id);
				window.location.hash = hash;
			},

			tabsAutoPlay() {

				if((this.countTab - 1) > this.activeTab) {
					this.activeTab++;
				} else {
					this.activeTab = 0;
				}

				setTimeout(this.tabsAutoPlay, 6000);
			},

			getAttribute(index) {
				let getAttribute = this.$refs['tab-' + index].getAttribute('data-slug');
				if(getAttribute) {
					window.location.hash = getAttribute;
				}
			},

			prevClick() {
				if(this.activeTab > 0) {
					let elementPrev = this.$refs['tab-' + this.activeTab];
					this.activeTab--;
					this.$refs.tablist.scrollLeft -= elementPrev.offsetWidth;

					this.getAttribute(this.activeTab);
				}
			},

			nextClick() {
				if(this.activeTab < this.allTabs) {
					let elementNext = this.$refs['tab-' + this.activeTab];
					this.activeTab++;
					this.$refs.tablist.scrollLeft += elementNext.offsetWidth;

					this.getAttribute(this.activeTab);
				}
			},

			dotsClick(id) {
				let left = 0;
				left     = this.$refs['tab-' + this.activeTab].getBoundingClientRect().left;

				this.$refs.tablist.scrollLeft += left - 20;
			}
		},

		mounted() {
			if(window.location.hash) {
				let hash = window.location.hash;
				hash     = hash.split('#')
							   .join('');

				for(let key in this.terms) {
					if(this.terms[key].terms === hash) {
						this.activeTab = parseInt(key);
					}
				}
			}

			if(this.isHome) {
				if(this.terms) {
					this.countTab = this.terms.length;

					if(this.countTab != null) {
						this.tabsAutoPlay();
					}
				}
			}

			if(this.$refs.tablist && this.$refs['tab-' + this.activeTab]) {
				this.$refs.tablist.scrollLeft += this.$refs['tab-' + this.activeTab].offsetLeft;
			}
		}
	};
</script>

<style scoped>

</style>